import useCallApi from '../../../hooks/useCallApi'
import Campaign from '../../../templates/Campaign/Campaign'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import Dollars from '../../../templates/Dollars/Dollars'
import { Card } from 'react-bootstrap'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import moment from 'moment/moment'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import AdvertiserRatePitch from '../../../components/AdvertiserRatePitchContent/AdvertiserRatePitchContent'


const RatePitchCampaignReport = ({ ratePitchId }) => {
    const { data, dataLoaded, refetch } = useCallApi(`advertisers/ratePitchCampaignsReport/${ratePitchId}`, 'GET', {}, [])
    const [workingId, setWorkingId] = useState(false)
    const [showModal, setShowModal] = useState(false)


    const openModal = (e, id) => {
        e.preventDefault();
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        refetch();
    }

    const getReportOutput = () => {
        let columns = [
            {
                Header: 'Campaign ID',
                accessor: 'id',
            },
            {
                Header: 'Campaign',
                accessor: 'name',
                Cell: ({ cell: { value, row } }) => {
                    return (<Campaign oid={row.original.id} name={value} />)
                }
            },
            {
                Header: () => (
                    <div style={{ textAlign: 'right', width: '100%' }}>
                        Lifetime Margin
                    </div>
                ),
                accessor: 'lifetime_margin',
                sortType: 'number',
                Cell: ({ cell: { value } }) => {
                    return (
                        <div className="text-right">
                            <Dollars value={value ? value : 0} />
                        </div>
                    )
                }
            },
        ]

        return (
            <>
                <ReportTable data={data.campaigns} columns={columns} />
            </>
        )
    }

    return (
        <>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Rate Pitch Campaign Report</h1>
            </div>
            <div className="col-lg-4">
                <Card className="mb-3">
                    {dataLoaded ? (
                        <div className="d-flex border rounded justify-content-between">
                            <div className="mx-2 p-2 d-flex align-items-center"><Advertiser id={data.pitch.advertiser.id} name={data.pitch.advertiser.name} /></div>
                            <div className="mx-2 border-left p-2"><strong>{data.pitch.admin.name}</strong><div className="text-secondary">{moment(data.pitch.db_date).utc().format('YYYY-MM-DD HH:mm')}</div></div>
                            <div className="mx-2 border-left p-2"><strong>{data.pitch.status.name}</strong><div className="text-secondary">{moment(data.pitch.status.date).utc().format('YYYY-MM-DD HH:mm')}</div></div>
                            <div className="mx-2 border-left p-2">
                                <div className="d-flex justify-content-start">
                                    <Modal show={showModal} size="xl" onHide={() => setShowModal(false)}>
                                        <AdvertiserRatePitch ratePitchId={workingId} refetch={refetch} closeModal={closeModal} />
                                    </Modal>
                                    <Link to={`/advertisers/ratePitch/${data.pitch.id}`} className="btn btn-warning btn-sm my-2" onClick={(e) => { setWorkingId(data.pitch.id); openModal(e, data.pitch.id) }}>View</Link>
                                </div>
                            </div>
                        </div>
                    ) : <Loading />}
                </Card>
                <Card>
                    <Card.Header className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <h1 className="mb-h1-dark mr-2">Rate Pitch Campaigns</h1>
                        </div>
                    </Card.Header>
                    {dataLoaded ? data.campaigns.length === 0 ? <div className="p-3">No leads generated on campaigns since rate change</div> : getReportOutput() : <Loading />}
                </Card >
            </div >
        </>
    )

}

export default RatePitchCampaignReport